var _defs, _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _path4, _path5, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrantJournal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 25.14,
    y1: 56.84,
    x2: 52.66,
    y2: 56.84
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#a)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M25.77 56.84h26.26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#434548",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M60.77 36.75V5.25h-40.9l.03 51.32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.93 53.74H23c-1.71 0-3.1 1.4-3.1 3.1 0 1.71 1.4 3.1 3.1 3.1h32.14",
    fill: "none",
    stroke: "#434548",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.31,
    cy: 44.7,
    r: 2.02,
    fill: "none",
    stroke: "#434548",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.31,
    cy: 34.56,
    r: 2.02,
    fill: "none",
    stroke: "#434548",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.31,
    cy: 24.41,
    r: 2.02,
    fill: "none",
    stroke: "#434548",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.31,
    cy: 14.27,
    r: 2.02,
    fill: "none",
    stroke: "#434548",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#a)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.19 44.7h4.09M18.19 34.56h4.09M18.19 24.41h4.09M18.19 14.27h4.09M70.04 50.69L57.96 62.77 45.88 50.69a8.534 8.534 0 010-12.08 8.534 8.534 0 0112.08 0 8.534 8.534 0 0112.08 0c3.34 3.33 3.34 8.74 0 12.08z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.54 46.99s-.42-2.45-2.45-2.45-2.58 2.45-2.58 2.45l5.27 4M55.76 50.99s.42 2.45 2.45 2.45 2.58-2.45 2.58-2.45M58.15 42.45v2.09M58.15 53.45v2.09M36.7 16.43h13.18M38.9 19.2h8.46",
    fill: "none",
    stroke: "var(--icon-menu-gradient-end, #b10372)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.08,
    y: 12.26,
    width: 24.16,
    height: 11.35,
    rx: 3,
    fill: "none",
    stroke: "#434548",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrantJournal);
export default __webpack_public_path__ + "static/media/grantJournal.ddb57d322485b99de71eac8b30668e4c.svg";
export { ForwardRef as ReactComponent };